import React from "react";
const useGetWixClientPromise = (instance, wixClient) => {
  const wixClientGetter = React.useMemo(
    () => wixClient ? () => Promise.resolve(wixClient) : void 0,
    [wixClient]
  );
  const instanceGetter = React.useMemo(() => {
    let wixClientPromise;
    return () => {
      if (wixClientPromise) {
        return wixClientPromise;
      }
      wixClientPromise = import(
        /* webpackChunkName: "wix-ricos-sdk-client" */
        "@wix/sdk/client"
      ).then((clientSdk) => {
        return clientSdk.createClient({
          auth: {
            getAuthHeaders: () => ({ headers: { Authorization: instance } })
          }
        });
      });
      return wixClientPromise;
    };
  }, [instance]);
  return React.useMemo(
    () => ({ getWixClientPromise: wixClientGetter ?? instanceGetter }),
    [wixClientGetter, instanceGetter]
  );
};
export {
  useGetWixClientPromise
};
//# sourceMappingURL=use-get-wix-client-promise.js.map
